import SelectBox, {
  Item,
  MultiSelectProps,
  OtherSelectBoxProps,
  SingleSelectProps,
} from '@/components/select/SelectBox';

const netContentUnits = [
  { id: 'g', name: 'Gram (g)' },
  { id: 'kg', name: 'Kilogram (kg)' },
  { id: 'mg', name: 'Milligram (mg)' },
  { id: 'ml', name: 'Milliliter (ml)' },
  { id: 'l', name: 'Liter (l)' },
  { id: 's', name: 'Sachet (s)' },
] as const;

export interface NetContentUnitItem extends Item {
  id: string;
  name: string;
}

type NetContentUnitSelectBoxProps<T extends Item> =
  | (SingleSelectProps<T> &
      OtherSelectBoxProps<T> & {
        multiple?: false;
      })
  | (MultiSelectProps<T> &
      OtherSelectBoxProps<T> & {
        multiple: true;
      });

const NetContentUnitSelectBox = (props: NetContentUnitSelectBoxProps<NetContentUnitItem>) => {
  const { label = 'Net Content Unit:', placeholder = 'Select unit' } = props;

  const listUnits = (): Promise<NetContentUnitItem[]> => {
    return new Promise((resolve) => {
      resolve([...netContentUnits]);
    });
  };

  return (
    <SelectBox<NetContentUnitItem>
      {...props}
      name="netContent.unit"
      label={label}
      placeholder={placeholder}
      queryFn={listUnits}
      itemRender={(item: NetContentUnitItem, selected?: boolean) => (
        <div className="flex items-center">
          <span className={`${selected ? 'font-semibold' : 'font-normal'} block truncate`}>
            {item.name}
          </span>
        </div>
      )}
    />
  );
};

export default NetContentUnitSelectBox;
